import BaseUseCase from "../base_use_case.js.jsx";
class SendResetPasswordUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/passwords/send_reset_password_instructions`,
      data: this.wrapParams(params, "user")
    });
  }
}

const instance = new SendResetPasswordUseCase();
export default instance;